<template>
  <DefaultLoading message="页面加载中..."></DefaultLoading>
</template>

<script>
import DefaultLoading from '../loader/DefaultLoading'
export default {
  name: 'AsyncLoading',
  components: {
    DefaultLoading
  }
}
</script>
